import * as Types from '../../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type TemplateDetailsForTemplateReferenceInspectorFragment = { __typename: 'Template', revisions: Array<{ __typename: 'TemplateRevision', id: string, legacyId: number, number: number }>, latestRevision?: { __typename: 'TemplateRevision', id: string, legacyId: number, number: number } | null };

export type GetTemplateDetailsForTemplateReferenceInspectorQueryVariables = Types.Exact<{
  legacyId: Types.Scalars['Int']['input'];
}>;


export type GetTemplateDetailsForTemplateReferenceInspectorQuery = { __typename: 'Query', template: { __typename: 'Template', revisions: Array<{ __typename: 'TemplateRevision', id: string, legacyId: number, number: number }>, latestRevision?: { __typename: 'TemplateRevision', id: string, legacyId: number, number: number } | null } };

export const TemplateDetailsForTemplateReferenceInspectorFragmentDoc = gql`
    fragment TemplateDetailsForTemplateReferenceInspector on Template {
  revisions {
    id
    legacyId
    number
  }
  latestRevision {
    id
    legacyId
    number
  }
}
    `;
export const GetTemplateDetailsForTemplateReferenceInspectorDocument = gql`
    query getTemplateDetailsForTemplateReferenceInspector($legacyId: Int!) {
  template(legacyId: $legacyId) {
    ...TemplateDetailsForTemplateReferenceInspector
  }
}
    ${TemplateDetailsForTemplateReferenceInspectorFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTemplateDetailsForTemplateReferenceInspectorGQL extends Apollo.Query<GetTemplateDetailsForTemplateReferenceInspectorQuery, GetTemplateDetailsForTemplateReferenceInspectorQueryVariables> {
    override document = GetTemplateDetailsForTemplateReferenceInspectorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }